import * as React from "react";
import * as ReactDom from "react-dom";
import { baseUrl } from "./apiConfig";
import { App } from "./App";
import { AppProvider } from "./AppProvider";
import "./index.css";
import { initTranslator } from "./locales";
import "./locales";

initTranslator(baseUrl);

ReactDom.render(
  <AppProvider autoLoginAzureAd={true}>
    <App />
  </AppProvider>,
  document.getElementById("root")
);
